













import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'CountriesAndRegions',
  components: {
    CountriesTable: () => import('@/views/market/countries/countries-table.vue'),
    RegionsTable: () => import('@/views/market/regions/regions-table.vue')
  }
})
export default class extends Vue {
  private activeTab = 'countries'

  created() {
    const tab = this.$route.query.tab as string
    if (tab === 'regions' || tab === 'countries') {
      this.activeTab = tab
    }
  }

  private onTabChange() {
    this.$router.replace({ query: { tab: this.activeTab } }).catch(err => err)
  }
}
